import Vue from 'vue'
import axios from 'axios'

import { getUserFromLocalStorage } from '~/utils/auth'
import { setToken, unsetToken, checkSecret } from '../../utils/auth'

import * as TYPE from '../util/types'

const state = () => ({
	authModalOpen: false,
	authUser: {},
	token: '',
	host: null,
	authRedirect: null
})

const actions = {
	setHostProp({ commit }, payload) {
		commit(TYPE.SET_HOST_PROP, payload)
	},
	setToken({ commit, dispatch }, token) {
		axios.interceptors.response.use(null, error => {
			if (
				error.hasOwnProperty('response') &&
				typeof error.response === 'object'
			) {
				if (error.response.hasOwnProperty('status')) {
					if (error.response.status === 401) {
						console.log('error 401')
						// dispatch('logout')
						return Promise.reject(error)
					}
				}
			}
			return Promise.reject(error)
		})
		setToken(token)
		commit(TYPE.SET_TOKEN, token)
	},
	setAuthModalOpen({ commit }, value) {
		commit(TYPE.SET_AUTH_MODAL_OPEN, value)
	},
	serverPutUserProp({ commit }, payload) {
		let pk = payload.pk
		let userProps = payload.userProps
		return axios
			.put('/api/v1/user/' + pk + '/', userProps)
			.then(response => {
				// console.log(response)
				return response
			})
			.catch(error => {
				console.error(error)
			})
	},
	setUserProp ({commit, state}, payload) {
		for (let prop in payload) {
			if (payload.hasOwnProperty(prop)) {
				// console.log(prop, payload[prop])
				commit(TYPE.SET_USER_PROP, {
					prop: prop,
					value: payload[prop]
				})
			}
		}
	},
	setUserHost({ commit }, payload) {
		commit(TYPE.SET_HOST, payload)
	},
	setUserSocial({ commit, state }, payload) {
		// console.log('setUserSocial')
		const newUser = {
			uuid: null,
			pk: null,
			emailaddresses: [],
			password_set: false,
			groups: [],
			is_premium: null,
			last_location: null,
			gender: null,
			birthday: null,
			email: null,
			liked_events: [],
			liked_locations: [],
			past_events: [],
			username: null,
			first_name: null,
			free_pass: null,
			last_name: null,
			avatar: null,
			interests: null,
			social_linkedin: null,
			social_twitter: null,
			social_facebook: null,
			heading: null,
			bio: null,
			active: null,
			where_from: null,
		}
		for (let prop in newUser) {
			if (newUser.hasOwnProperty(prop)) {
				if (payload.hasOwnProperty(prop)) {
					newUser[prop] = payload[prop]
				}
			}
		}
		commit(TYPE.SET_USER, newUser)
		if (payload.host) {
			commit(TYPE.SET_HOST, payload.host)
		}
	},
	logout({ commit }) {
		commit(TYPE.SET_TOKEN, '')
		commit(TYPE.SET_HOST, null)
		commit(TYPE.SET_USER, null)
		unsetToken()
		window.localStorage.clear()
		axios
			.post('/rest-auth/logout/')
			.then(response => {
				delete axios.defaults.headers.common['Authorization']
				delete axios.defaults.headers['Authorization']
				window.location = '/'
			})
			.catch(error => {
				console.error(error)
				delete axios.defaults.headers.common['Authorization']
				delete axios.defaults.headers['Authorization']
				window.location = '/'
			})
	},
	setAuthRedirect({ commit }, value) {
		commit(TYPE.SET_AUTH_REDIRECT, value)
	}
}

const mutations = {
	[TYPE.SET_AUTH_MODAL_OPEN]: (state, value) => {
		state.authModalOpen = value
	},
	[TYPE.SET_AUTH_REDIRECT]: (state, value) => {
		state.authRedirect = value
	},
	[TYPE.SET_USER_PROP]: (state, payload) => {
		// console.log('TYPE.SET_USER_PROP')
		if (!state.authUser) {
			state.authUser = {}
		}
		Vue.set(state.authUser, payload.prop, payload.value)
		window.localStorage.setItem('user', JSON.stringify(state.authUser))
	},
	[TYPE.SET_HOST_PROP]: (state, payload) => {
		if (!state.host) {
			state.host = {}
		}
		Vue.set(state.host, payload.prop, payload.value)
		window.localStorage.setItem('host', JSON.stringify(state.host))
	},
	[TYPE.SET_USER]: (state, payload) => {
		Vue.set(state, 'authUser', payload)
		window.localStorage.setItem('user', JSON.stringify(state.authUser))
	},
	[TYPE.SET_HOST]: (state, payload) => {
		Vue.set(state, 'host', payload)
	},
	[TYPE.SET_TOKEN]: (state, value) => {
		state.token = value
	}
}

const getters = {
	userIsAuthenticated: state => {
		return (
			state.token !== '' && state.token !== null && state.token !== undefined
		)
	},
	user: state => state.authUser,
	userIsHost: state => {
		if (!state.host) {
			return false
		} else {
			if (state.host.approved) {
				return true
			}
		}
		return false
	},
	userHasHostRequest: state => {
		if (!state.host) {
			return false
		} else {
			if (!state.host.approved) {
				return true
			}
		}
		return false
	},
	getHost: state => state.host,
	getToken: state => state.token,
	getAuthRedirect: state => state.authRedirect,
	getAuthModalOpen: state => state.authModalOpen
}

export default {
	state,
	getters,
	mutations,
	actions
}
